<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19 13c-4.901.424-7.576 3.099-8 8-.442-4.977-3.103-7.445-8-8 4.975-.574 7.426-3.025 8-8 .555 4.897 3.023 7.558 8 8"
      stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    />
    <path
      d="M18.886 2.345a.389.389 0 0 0-.772 0c-.106.914-.377 1.54-.803 1.966-.425.426-1.052.697-1.967.803a.389.389 0 0 0 .001.772c.899.102 1.54.374 1.977.802.434.426.71 1.052.79 1.958a.389.389 0 0 0 .775-.001c.078-.89.354-1.53.79-1.967s1.078-.714 1.968-.79a.389.389 0 0 0 0-.775c-.905-.08-1.53-.357-1.957-.791-.428-.437-.7-1.078-.802-1.977"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
